import styled from '@emotion/styled'

export const S = {
  Container: styled.div<{ $fullscreen: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.marko.variables.spacing.distance.medium}px;
    padding: ${({ theme }) => theme.marko.variables.spacing.distance.large}px;
    min-height: ${({ $fullscreen }) => ($fullscreen ? '100vh' : '40vh')};
    text-align: center;
    color: ${({ theme }) => theme.marko.colors.text};
  `,

  Title: styled.h1`
    margin: 0;
    font-size: ${({ theme }) => theme.marko.typography.fontSizes.extraLarge};
    font-weight: ${({ theme }) => theme.marko.typography.fontWeights.title};
    font-family: ${({ theme }) => theme.marko.typography.fontFamilyTitle};
  `,

  Message: styled.p`
    margin: 0;
    color: ${({ theme }) => theme.marko.colors.textSecondary};
  `,

  Actions: styled.div`
    display: flex;
    gap: ${({ theme }) => theme.marko.variables.spacing.distance.small}px;
  `,

  Details: styled.details`
    max-width: 720px;
    width: 100%;
    text-align: left;
  `,

  Pre: styled.pre`
    border-radius: ${({ theme }) => theme.marko.variables.borderRadius.small}px;
    padding: ${({ theme }) => theme.marko.variables.spacing.distance.small}px;
    overflow: auto;
    font-size: ${({ theme }) => theme.marko.typography.fontSizes.small};
  `,
} as const
